import Head from 'next/head'
import React from 'react'

import { APP_STORE_ID } from '../../constants/appLinks'

/**
 * Smart App Banner nativo do Safari/iOS. Só é emitido quando existe um App
 * Store ID real configurado (ver `constants/appLinks.ts`). O `app-argument`
 * leva a URL atual para o app abrir direto no conteúdo via Universal Link.
 */
export function AppleSmartBanner({ url }: { url?: string }) {
  if (!APP_STORE_ID) return null

  const content = url
    ? `app-id=${APP_STORE_ID}, app-argument=${url}`
    : `app-id=${APP_STORE_ID}`

  return (
    <Head>
      <meta name="apple-itunes-app" content={content} />
    </Head>
  )
}
